function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Designs",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Stimson-UN-Handbook-Desktop-1",
  transform: "translate(-1309.000000, -20.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Search/Unselected",
  transform: "translate(1280.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic-search-24px",
  transform: "translate(29.000000, 20.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.981,12.628 L13.26842,12.628 L13.01586,12.38446 C13.89982,11.35618 14.432,10.02122 14.432,8.569 C14.432,5.33082 11.80718,2.706 8.569,2.706 C5.33082,2.706 2.706,5.33082 2.706,8.569 C2.706,11.80718 5.33082,14.432 8.569,14.432 C10.02122,14.432 11.35618,13.89982 12.38446,13.01586 L12.628,13.26842 L12.628,13.981 L17.138,18.48198 L18.48198,17.138 L13.981,12.628 Z M8.569,12.628 C6.32302,12.628 4.51,10.81498 4.51,8.569 C4.51,6.32302 6.32302,4.51 8.569,4.51 C10.81498,4.51 12.628,6.32302 12.628,8.569 C12.628,10.81498 10.81498,12.628 8.569,12.628 Z",
  id: "Shape",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 21.648 0 21.648 21.648 0 21.648"
})))));

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4B94A16E-A8DA-4651-B319-E6341E918A73") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.46477f8a.svg";
export { ForwardRef as ReactComponent };